import controller from './product-categories.controller'
import template   from './product-categories.html'
import './product-categories.styl'

let component = {
  restrict: 'E',
  bindings: {
    categories: '<'
  },
  controller,
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/product-categories/product-categories.component.js